import { useAppSelector } from "../../hooks";
import RefreshQuoteData from "./RefreshQuoteData";
import InitStampDuty from "./InitStampDuty";
import InitQuoteDataOptionalExtras from "./InitQuoteDataOptionalExtras";
import { selectMe } from "../../lib/store/features/user.slice";

function Init() {
  const me = useAppSelector(selectMe);

  return (
    <>
      {!!me && <RefreshQuoteData />}
      {!!me && <InitQuoteDataOptionalExtras />}
      {!!me && <InitStampDuty />}
    </>
  );
}

export default Init;
